export default __webpack_public_path__ + "static/media/WhiteThumbIcon.05cb241d.svg";